/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.16",
    versionName: "0.2.0-nightly.2026.1.16",
    versionChannel: "nightly",
    buildDate: "2026-01-16T00:07:44.431Z",
    commitHash: "16564428043159f33ac27656f151ada80d95a3a0",
};
